import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Button from 'shared/button';
import { post } from 'helpers/api';

export default function CreateListingControls({ deal, onClose, onCreate }) {
  const [saving, setSaving] = useState();

  async function createListing() {
    setSaving(true);
    const listing = await post(deal.createListingPath);
    setSaving(false);
    onCreate(listing);
  }

  return <React.Fragment>
    <Button.Cancel onClick={onClose} />
    <Button.Primary disabled={saving} onClick={createListing}>
      Create Listing
    </Button.Primary>
  </React.Fragment>;
}

CreateListingControls.propTypes = {
  deal: PropTypes.shape({
    createListingPath: PropTypes.string.isRequired,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
};
